import SuspenseWrapper from '@src/components/suspenseWrapper';
import Loader from '@src/components/loader';
import lazyWithPreload from '@src/utils/lazyWithPreload';
import { RouteObject } from 'react-router-dom';
import { Path } from '../routes';
import Error from '@src/pages/error';
import Box from '@sendsprint/ui-react/dist/components/Box';

export const VerifyEmail = lazyWithPreload(() => import('@src/pages/auth/verifyEmail'));
export const PaymentSuccess = lazyWithPreload(() => import('@src/pages/callbacks/paymentSuccess'));
export const ModulrCallback = lazyWithPreload(
  () => import('@src/pages/callbacks/modulrCallbackPage')
);
export const PaymentCallback = lazyWithPreload(
  () => import('@src/pages/callbacks/paymentCallbackPage')
);

const routesData = [
  { path: Path.VerifyEmail, component: <VerifyEmail /> },
  { path: Path.PaymentSuccess, component: <PaymentSuccess /> },
  { path: Path.ModulrCallback, component: <ModulrCallback /> },
  { path: Path.PaymentCallback, component: <PaymentCallback /> },
  { path: Path.StripeCallback, component: <PaymentCallback /> }
];

export const generalRoutes: RouteObject[] = routesData.map(({ component, path }) => ({
  path,
  element: (
    <SuspenseWrapper
      errorFallback={({ resetError }) => (
        <Box className="">
          <Error resetError={resetError} />
        </Box>
      )}
      suspenseFallback={<Loader className="" showTimedOutScreen />}>
      {component}
    </SuspenseWrapper>
  )
}));
